import { Box, TextField, InputAdornment, IconButton, useTheme } from '@mui/material';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  useGridApiContext,
  useGridSelector,
  gridFilterModelSelector,
} from '@mui/x-data-grid-pro';
import { useState, useEffect } from 'react';

import { Icon } from '@verantos-dev/shared-components';

export const DataGridToolbar = () => {
  const apiRef = useGridApiContext();
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const [searchValue, setSearchValue] = useState('');

  // Sync with DataGrid's quick filter state
  useEffect(() => {
    const quickFilterValues = filterModel?.quickFilterValues || [];
    setSearchValue(quickFilterValues.join(' ') || '');
  }, [filterModel]);

  // Handle search input change
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchValue(value);
    apiRef.current.setQuickFilterValues(value.trim() ? [value.trim()] : []);
  };

  // Handle clear button click
  const handleClear = () => {
    setSearchValue('');
    apiRef.current.setQuickFilterValues([]);
  };

  const theme = useTheme();
  return (
    <GridToolbarContainer
      sx={{
        pt: 2,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <GridToolbarColumnsButton />

      <Box sx={{ ml: 'auto', width: 400 }}>
        <TextField
          placeholder="Search..."
          value={searchValue}
          onChange={handleSearchChange}
          size="small"
          fullWidth
          InputProps={{
            endAdornment: searchValue ? (
              <InputAdornment position="end">
                <IconButton onClick={handleClear} edge="end" sx={{ padding: theme.spacing(4) }}>
                  <Icon id="data-grid-toolbar-clear-icon" icon="clear" width={12} height={12} />
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
          sx={{
            '& .MuiInputBase-root': {
              height: '36px',
            },
          }}
        />
      </Box>
    </GridToolbarContainer>
  );
};
